export const TELEGRAM_COMPONENT = 'telegram';
